import ContentwithPhotoFeed from './ContentwithPhotoFeed'

export default ContentwithPhotoFeed
